// extracted by mini-css-extract-plugin
export default {"articlePage":"article_page_articlePage__ER4OZ","blocksContainer":"article_page_blocksContainer__Z26Dh","blockWrapper":"article_page_blockWrapper__HW+57"};